import { Download, FileArchive } from 'lucide-react'

import { Button } from '@/components/ui/button'

import { getDisplayFileName } from '@/utils/display-file-name'

import type { ResourceType } from '@/types/resource.type'

export function ZipContentViewer({
  resource,
  isDownloadable = false,
}: {
  resource: ResourceType
  isDownloadable?: boolean
}) {
  const fileName = getDisplayFileName(resource.fileName, 'archive.zip')

  return (
    <div className="flex flex-col h-screen w-full items-center justify-center bg-muted/30 p-6">
      <div className="flex max-w-md flex-col items-center gap-6 rounded-xl border border-border bg-background p-8 text-center shadow-sm">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-muted">
          <FileArchive className="size-8 text-muted-foreground" />
        </div>
        <div className="space-y-2">
          <h3 className="text-lg font-semibold">ZIP Archive</h3>
          <p className="text-sm text-muted-foreground">
            ZIP files cannot be previewed in the browser. Download the file to access its contents.
          </p>
        </div>
        <p className="text-sm text-muted-foreground">{fileName}</p>
        {isDownloadable && (
          <Button
            size="lg"
            className="gap-2"
            onClick={() => {
              const link = document.createElement('a')
              link.href = resource.url
              link.download = fileName
              link.rel = 'noopener noreferrer'
              link.click()
            }}
          >
            Download
            <Download className="size-4" />
          </Button>
        )}
      </div>
    </div>
  )
}
